<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                {{year}} © FERRECAST
            </div>
            <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                    Diseño y desarrollo por: <i class="mdi mdi-desktop-mac-dashboard text-info"></i> https://devsolutionsoft.com <i class="mdi mdi-desktop-mac-dashboard text-info"></i>
                </div>
            </div>
        </div>
    </div>
</footer>